import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'Mundo Gamer Network',
    logo: require('@/assets/images/logos/mg_network.png'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'semi-dark', // default, bordered, semi-dark
    contentWidth: 'boxed',
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#ee3831',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
      // Neutral chip fills (key type, region, platform in the requests list).
      // Material colour names such as "blue-grey darken-1" are not emitted by
      // this theme, so they rendered nothing; these are the greys those chips
      // always had, now as theme colours.
      neutral: '#546e7a',
      muted: '#6c757d',
    },
    dark: {
      primary: '#ee3831',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
      // Neutral chip fills (key type, region, platform in the requests list).
      // Material colour names such as "blue-grey darken-1" are not emitted by
      // this theme, so they rendered nothing; these are the greys those chips
      // always had, now as theme colours.
      neutral: '#546e7a',
      muted: '#6c757d',
    },
  },
}

export default themeConfig
